@import '../../style/index';

:host {
  display: flex;
  flex-direction: column;
  gap: var(--spacings-m);
  margin-top: var(--spacings-m);
  @include xlarge-up {
    display: flex;
    gap: var(--spacings-m);
    margin-top: unset;
    flex-direction: unset;
  }
}
